import {element_exists} from "../functions";

export var fnExportEmployeeChanges = function () {

    var tableName = '#datatable-customer-employees';

    if (!element_exists(tableName)) return false;

    var btnSelector = '.btn-export-employee-changes';
    $(document).off('click', btnSelector);
    $(document).on('click', btnSelector, function (e) {
        //e.preventDefault();
        document.location.href = $(this).attr('data-href');
    });
};